// extracted by mini-css-extract-plugin
module.exports = {"container":"idt-photoprinterrorwrapper_container__zymas"};